import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import transform from 'lodash-es/transform';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { SelectItem } from 'primeng/api';

@Injectable()
export class CoachSettingsGeneralSectorsController {
	public sectorOptions$: Observable<SelectItem[]>;

	constructor(private _translateService: TranslateService) {
		this._initObservables();
	}

	private _initObservables() {
		this.sectorOptions$ = this._translateService
			.stream('presentation.app.common.coach.sectors')
			.pipe(
				map((sectors) =>
					transform<string, SelectItem[]>(
						sectors,
						(result, value, key) => result.push({ value: key, label: value }),
						[]
					)
				),
				shareReplay({ bufferSize: 1, refCount: true })
			);
	}
}
